const Pdf = () => {
    const element = <div className="common_main">
        <iframe width={1220} height={500} src="https://refox.oss-ap-southeast-1.aliyuncs.com/iPhone%20X%20won%27t%20turn%20on%20issue.pdf"></iframe>
    </div>
    return element
}
export default Pdf